import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import LandingPage from './pages/landing_page';
import WebsiteBuilderLanding from './pages/WebsiteBuilderLanding';
import Login from './pages/Login';
import ContactUs from './pages/ContactUs';
import HomePage from './pages/HomePage';
import Register from './components/Register';
import PrivateRoute from './utils/PrivateRoute';
import { AuthProvider } from './context/AuthContext';
import Base from './components/Base'
import TermsAndServices from './components/TermsNcondn';
import ReturnPolicy from './components/ReturnPolicy';
import PaymentShipping from './components/PaymentShipping';
import PrivacyPolicy from './components/PrivacyPolicy';
import Faqs from './components/Faqs';
import Uploadproduct from './pages/Uploadproduct';
import Profile from './components/Profile';
import  Contact  from './components/Contact';
import AboutMe from './components/AboutMe';
import Orders from './components/Orders';
import Proposals from './components/Proposals';
import EditProduct from './components/EditProduct';
import ForgotPassword from './components/ForgotPassword';
import TemplateSelector from './components/Subscription';
import TemplateThemes from './pages/TemplateThemes';
import VisualTemplateEditor from './pages/VisualTemplateEditor';
import TestPage from './pages/TestPage';
import DesignerOnboarding from './components/DesignerOnboarding';
import AdminDesignerDashboard from './components/AdminDesignerDashboard';
import DesignerProfile from './components/DesignerProfile';
import MyCoupons from './pages/MyCoupons';
import Analytics from './pages/Analytics';
import SEOSettings from './pages/SEOSettings';
import CollectionsManager from './pages/CollectionsManager';
import OrderBook from './components/orderbook/OrderBook';

// New Admin Dashboard
import AdminDashboard from './components/admin/AdminDashboard';
import AdminRoute from './components/admin/AdminRoute';

// Template Builder
import PageDashboard from './components/TemplateBuilder/PageDashboard';

import Template1 from './components/Templates/Template1';
import Template2 from './components/Templates/Template2';
import Template3 from './components/Templates/Template3';
import Template4 from './components/Templates/Template4';
import Template5 from './components/Templates/Template5';
import Template6 from './components/Templates/Template6';
import Template7 from './components/Templates/Template7';
import Template8 from './components/Templates/Template8';
import Template9 from './components/Templates/Template9';
import Template10 from './components/Templates/Template10';
import Template11 from './components/Templates/Template11';
import Template12 from './components/Templates/Template12';
import Template13 from './components/Templates/Template13';
import Template14 from './components/Templates/Template14';
import Template15 from './components/Templates/Template15';
import Template16 from './components/Templates/Template16';
import Template17 from './components/Templates/Template17';
import Template18 from './components/Templates/Template18';
import Template19 from './components/Templates/Template19';
import Template20 from './components/Templates/Template20';
import Template21 from './components/Templates/Template21';
import Template22 from './components/Templates/Template22';
import Template23 from './components/Templates/Template23';
import Template24 from './components/Templates/Template24';
import Template25 from './components/Templates/Template25';

// Template1 Pages
import Template1Shop from './components/Templates/Template1Pages/shop1';
import Template1ProductDetail from './components/Templates/Template1Pages/ProductDetail1';
import Template1Cart from './components/Templates/Template1Pages/Cart1';
import Template1Checkout from './components/Templates/Template1Pages/Checkout1';
import Template1Login from './components/Templates/Template1Pages/Login1';
import Template1Signup from './components/Templates/Template1Pages/Signup1';
import Template1Orders from './components/Templates/Template1Pages/Orders1';
import Template1Contact from './components/Templates/Template1Pages/Contact1';
import Template1Profile from './components/Templates/Template1Pages/Profile1';
import Template1About from './components/Templates/Template1Pages/About1';
import Template1TermsAndConditions from './components/Templates/Template1Pages/TermsAndConditions1';
import Template1PrivacyPolicy from './components/Templates/Template1Pages/PrivacyPolicy1';
import Template1ShippingAndExchange from './components/Templates/Template1Pages/ShippingAndExchange1';
import Template1FAQs from './components/Templates/Template1Pages/FAQs1';

// Template2 Pages
import Template2Shop from './components/Templates/Template2Pages/shop2';
import Template2ProductDetail from './components/Templates/Template2Pages/ProductDetail2';
import Template2Cart from './components/Templates/Template2Pages/Cart2';
import Template2Checkout from './components/Templates/Template2Pages/Checkout2';
import Template2Login from './components/Templates/Template2Pages/Login2';
import Template2Signup from './components/Templates/Template2Pages/Signup2';
import Template2Orders from './components/Templates/Template2Pages/Orders2';
import Template2Contact from './components/Templates/Template2Pages/Contact2';
import Template2Profile from './components/Templates/Template2Pages/Profile2';

// Template3 Pages
import Template3Shop from './components/Templates/Template3Pages/shop3';
import Template3ProductDetail from './components/Templates/Template3Pages/ProductDetail3';
import Template3Cart from './components/Templates/Template3Pages/Cart3';
import Template3Checkout from './components/Templates/Template3Pages/Checkout3';
import Template3Login from './components/Templates/Template3Pages/Login3';
import Template3Signup from './components/Templates/Template3Pages/Signup3';
import Template3Orders from './components/Templates/Template3Pages/Orders3';
import Template3Contact from './components/Templates/Template3Pages/Contact3';
import Template3Profile from './components/Templates/Template3Pages/Profile3';

// Template4 Pages
import Template4Shop from './components/Templates/Template4Pages/shop4';
import Template4ProductDetail from './components/Templates/Template4Pages/ProductDetail4';
import Template4Cart from './components/Templates/Template4Pages/Cart4';
import Template4Checkout from './components/Templates/Template4Pages/Checkout4';
import Template4Login from './components/Templates/Template4Pages/Login4';
import Template4Signup from './components/Templates/Template4Pages/Signup4';
import Template4Orders from './components/Templates/Template4Pages/Orders4';
import Template4Contact from './components/Templates/Template4Pages/Contact4';
import Template4Profile from './components/Templates/Template4Pages/Profile4';

// Template5 Pages
import Template5Shop from './components/Templates/Template5Pages/shop5';
import Template5ProductDetail from './components/Templates/Template5Pages/ProductDetail5';
import Template5Cart from './components/Templates/Template5Pages/Cart5';
import Template5Checkout from './components/Templates/Template5Pages/Checkout5';
import Template5Login from './components/Templates/Template5Pages/Login5';
import Template5Signup from './components/Templates/Template5Pages/Signup5';
import Template5Orders from './components/Templates/Template5Pages/Orders5';
import Template5Contact from './components/Templates/Template5Pages/Contact5';
import Template5Profile from './components/Templates/Template5Pages/Profile5';

// Template6 Pages
import Template6Shop from './components/Templates/Template6Pages/shop6';
import Template6ProductDetail from './components/Templates/Template6Pages/ProductDetail6';
import Template6Cart from './components/Templates/Template6Pages/Cart6';
import Template6Checkout from './components/Templates/Template6Pages/Checkout6';
import Template6Login from './components/Templates/Template6Pages/Login6';
import Template6Signup from './components/Templates/Template6Pages/Signup6';
import Template6Orders from './components/Templates/Template6Pages/Orders6';
import Template6Contact from './components/Templates/Template6Pages/Contact6';
import Template6Profile from './components/Templates/Template6Pages/Profile6';

// Template7 Pages
import Template7Shop from './components/Templates/Template7Pages/shop7';
import Template7ProductDetail from './components/Templates/Template7Pages/ProductDetail7';
import Template7Cart from './components/Templates/Template7Pages/Cart7';
import Template7Checkout from './components/Templates/Template7Pages/Checkout7';
import Template7Login from './components/Templates/Template7Pages/Login7';
import Template7Signup from './components/Templates/Template7Pages/Signup7';
import Template7Orders from './components/Templates/Template7Pages/Orders7';
import Template7Contact from './components/Templates/Template7Pages/Contact7';
import Template7Profile from './components/Templates/Template7Pages/Profile7';

// Template8 Pages
import Template8Shop from './components/Templates/Template8Pages/shop8';
import Template8ProductDetail from './components/Templates/Template8Pages/ProductDetail8';
import Template8Cart from './components/Templates/Template8Pages/Cart8';
import Template8Checkout from './components/Templates/Template8Pages/Checkout8';
import Template8Login from './components/Templates/Template8Pages/Login8';
import Template8Signup from './components/Templates/Template8Pages/Signup8';
import Template8Orders from './components/Templates/Template8Pages/Orders8';
import Template8Contact from './components/Templates/Template8Pages/Contact8';
import Template8Profile from './components/Templates/Template8Pages/Profile8';

// Template9 Pages
import Template9Shop from './components/Templates/Template9Pages/shop9';
import Template9ProductDetail from './components/Templates/Template9Pages/ProductDetail9';
import Template9Cart from './components/Templates/Template9Pages/Cart9';
import Template9Checkout from './components/Templates/Template9Pages/Checkout9';
import Template9Login from './components/Templates/Template9Pages/Login9';
import Template9Signup from './components/Templates/Template9Pages/Signup9';
import Template9Orders from './components/Templates/Template9Pages/Orders9';
import Template9Contact from './components/Templates/Template9Pages/Contact9';
import Template9Profile from './components/Templates/Template9Pages/Profile9';

// Template10 Pages
import Template10Shop from './components/Templates/Template10Pages/shop10';
import Template10ProductDetail from './components/Templates/Template10Pages/ProductDetail10';
import Template10Cart from './components/Templates/Template10Pages/Cart10';
import Template10Checkout from './components/Templates/Template10Pages/Checkout10';
import Template10Login from './components/Templates/Template10Pages/Login10';
import Template10Signup from './components/Templates/Template10Pages/Signup10';
import Template10Orders from './components/Templates/Template10Pages/Orders10';
import Template10Contact from './components/Templates/Template10Pages/Contact10';
import Template10Profile from './components/Templates/Template10Pages/Profile10';

// Template11 Pages
import Template11Shop from './components/Templates/Template11Pages/shop11';
import Template11ProductDetail from './components/Templates/Template11Pages/ProductDetail11';
import Template11Cart from './components/Templates/Template11Pages/Cart11';
import Template11Checkout from './components/Templates/Template11Pages/Checkout11';
import Template11Login from './components/Templates/Template11Pages/Login11';
import Template11Signup from './components/Templates/Template11Pages/Signup11';
import Template11Orders from './components/Templates/Template11Pages/Orders11';
import Template11Contact from './components/Templates/Template11Pages/Contact11';
import Template11Profile from './components/Templates/Template11Pages/Profile11';

// Template12 Pages
import Template12Shop from './components/Templates/Template12Pages/shop12';
import Template12ProductDetail from './components/Templates/Template12Pages/ProductDetail12';
import Template12Cart from './components/Templates/Template12Pages/Cart12';
import Template12Checkout from './components/Templates/Template12Pages/Checkout12';
import Template12Login from './components/Templates/Template12Pages/Login12';
import Template12Signup from './components/Templates/Template12Pages/Signup12';
import Template12Orders from './components/Templates/Template12Pages/Orders12';
import Template12Contact from './components/Templates/Template12Pages/Contact12';
import Template12Profile from './components/Templates/Template12Pages/Profile12';

// Template13 Pages
import Template13Shop from './components/Templates/Template13Pages/shop13';
import Template13ProductDetail from './components/Templates/Template13Pages/ProductDetail13';
import Template13Cart from './components/Templates/Template13Pages/Cart13';
import Template13Checkout from './components/Templates/Template13Pages/Checkout13';
import Template13Login from './components/Templates/Template13Pages/Login13';
import Template13Signup from './components/Templates/Template13Pages/Signup13';
import Template13Orders from './components/Templates/Template13Pages/Orders13';
import Template13Contact from './components/Templates/Template13Pages/Contact13';
import Template13Profile from './components/Templates/Template13Pages/Profile13';

// Template14 Pages
import Template14Shop from './components/Templates/Template14Pages/shop14';
import Template14ProductDetail from './components/Templates/Template14Pages/ProductDetail14';
import Template14Cart from './components/Templates/Template14Pages/Cart14';
import Template14Checkout from './components/Templates/Template14Pages/Checkout14';
import Template14Login from './components/Templates/Template14Pages/Login14';
import Template14Signup from './components/Templates/Template14Pages/Signup14';
import Template14Orders from './components/Templates/Template14Pages/Orders14';
import Template14Contact from './components/Templates/Template14Pages/Contact14';
import Template14Profile from './components/Templates/Template14Pages/Profile14';

// Template15 Pages
import Template15Shop from './components/Templates/Template15Pages/shop15';
import Template15ProductDetail from './components/Templates/Template15Pages/ProductDetail15';
import Template15Cart from './components/Templates/Template15Pages/Cart15';
import Template15Checkout from './components/Templates/Template15Pages/Checkout15';
import Template15Login from './components/Templates/Template15Pages/Login15';
import Template15Signup from './components/Templates/Template15Pages/Signup15';
import Template15Orders from './components/Templates/Template15Pages/Orders15';
import Template15Contact from './components/Templates/Template15Pages/Contact15';
import Template15Profile from './components/Templates/Template15Pages/Profile15';

// Template16 Pages
import Template16Shop from './components/Templates/Template16Pages/shop16';
import Template16ProductDetail from './components/Templates/Template16Pages/ProductDetail16';
import Template16Cart from './components/Templates/Template16Pages/Cart16';
import Template16Checkout from './components/Templates/Template16Pages/Checkout16';
import Template16Login from './components/Templates/Template16Pages/Login16';
import Template16Signup from './components/Templates/Template16Pages/Signup16';
import Template16Orders from './components/Templates/Template16Pages/Orders16';
import Template16Contact from './components/Templates/Template16Pages/Contact16';
import Template16Profile from './components/Templates/Template16Pages/Profile16';

// Template17 Pages
import Template17Shop from './components/Templates/Template17Pages/shop17';
import Template17ProductDetail from './components/Templates/Template17Pages/ProductDetail17';
import Template17Cart from './components/Templates/Template17Pages/Cart17';
import Template17Checkout from './components/Templates/Template17Pages/Checkout17';
import Template17Login from './components/Templates/Template17Pages/Login17';
import Template17Signup from './components/Templates/Template17Pages/Signup17';
import Template17Orders from './components/Templates/Template17Pages/Orders17';
import Template17Contact from './components/Templates/Template17Pages/Contact17';
import Template17Profile from './components/Templates/Template17Pages/Profile17';

// Template18 Pages
import Template18Shop from './components/Templates/Template18Pages/shop18';
import Template18ProductDetail from './components/Templates/Template18Pages/ProductDetail18';
import Template18Cart from './components/Templates/Template18Pages/Cart18';
import Template18Checkout from './components/Templates/Template18Pages/Checkout18';
import Template18Login from './components/Templates/Template18Pages/Login18';
import Template18Signup from './components/Templates/Template18Pages/Signup18';
import Template18Orders from './components/Templates/Template18Pages/Orders18';
import Template18Contact from './components/Templates/Template18Pages/Contact18';
import Template18Profile from './components/Templates/Template18Pages/Profile18';

// Template19 Pages
import Template19Shop from './components/Templates/Template19Pages/shop19';
import Template19ProductDetail from './components/Templates/Template19Pages/ProductDetail19';
import Template19Cart from './components/Templates/Template19Pages/Cart19';
import Template19Checkout from './components/Templates/Template19Pages/Checkout19';
import Template19Login from './components/Templates/Template19Pages/Login19';
import Template19Signup from './components/Templates/Template19Pages/Signup19';
import Template19Orders from './components/Templates/Template19Pages/Orders19';
import Template19Contact from './components/Templates/Template19Pages/Contact19';
import Template19Profile from './components/Templates/Template19Pages/Profile19';

// Template20 Pages
import Template20Shop from './components/Templates/Template20Pages/shop20';
import Template20ProductDetail from './components/Templates/Template20Pages/ProductDetail20';
import Template20Cart from './components/Templates/Template20Pages/Cart20';
import Template20Checkout from './components/Templates/Template20Pages/Checkout20';
import Template20Login from './components/Templates/Template20Pages/Login20';
import Template20Signup from './components/Templates/Template20Pages/Signup20';
import Template20Orders from './components/Templates/Template20Pages/Orders20';
import Template20Contact from './components/Templates/Template20Pages/Contact20';
import Template20Profile from './components/Templates/Template20Pages/Profile20';

// New Pages for Templates 2-20
import About2 from './components/Templates/Template2Pages/About2';
import TermsAndConditions2 from './components/Templates/Template2Pages/TermsAndConditions2';
import PrivacyPolicy2 from './components/Templates/Template2Pages/PrivacyPolicy2';
import ShippingAndExchange2 from './components/Templates/Template2Pages/ShippingAndExchange2';
import FAQs2 from './components/Templates/Template2Pages/FAQs2';
import About3 from './components/Templates/Template3Pages/About3';
import TermsAndConditions3 from './components/Templates/Template3Pages/TermsAndConditions3';
import PrivacyPolicy3 from './components/Templates/Template3Pages/PrivacyPolicy3';
import ShippingAndExchange3 from './components/Templates/Template3Pages/ShippingAndExchange3';
import FAQs3 from './components/Templates/Template3Pages/FAQs3';
import About4 from './components/Templates/Template4Pages/About4';
import TermsAndConditions4 from './components/Templates/Template4Pages/TermsAndConditions4';
import PrivacyPolicy4 from './components/Templates/Template4Pages/PrivacyPolicy4';
import ShippingAndExchange4 from './components/Templates/Template4Pages/ShippingAndExchange4';
import FAQs4 from './components/Templates/Template4Pages/FAQs4';
import About5 from './components/Templates/Template5Pages/About5';
import TermsAndConditions5 from './components/Templates/Template5Pages/TermsAndConditions5';
import PrivacyPolicy5 from './components/Templates/Template5Pages/PrivacyPolicy5';
import ShippingAndExchange5 from './components/Templates/Template5Pages/ShippingAndExchange5';
import FAQs5 from './components/Templates/Template5Pages/FAQs5';
import About6 from './components/Templates/Template6Pages/About6';
import TermsAndConditions6 from './components/Templates/Template6Pages/TermsAndConditions6';
import PrivacyPolicy6 from './components/Templates/Template6Pages/PrivacyPolicy6';
import ShippingAndExchange6 from './components/Templates/Template6Pages/ShippingAndExchange6';
import FAQs6 from './components/Templates/Template6Pages/FAQs6';
import About7 from './components/Templates/Template7Pages/About7';
import TermsAndConditions7 from './components/Templates/Template7Pages/TermsAndConditions7';
import PrivacyPolicy7 from './components/Templates/Template7Pages/PrivacyPolicy7';
import ShippingAndExchange7 from './components/Templates/Template7Pages/ShippingAndExchange7';
import FAQs7 from './components/Templates/Template7Pages/FAQs7';
import About8 from './components/Templates/Template8Pages/About8';
import TermsAndConditions8 from './components/Templates/Template8Pages/TermsAndConditions8';
import PrivacyPolicy8 from './components/Templates/Template8Pages/PrivacyPolicy8';
import ShippingAndExchange8 from './components/Templates/Template8Pages/ShippingAndExchange8';
import FAQs8 from './components/Templates/Template8Pages/FAQs8';
import About9 from './components/Templates/Template9Pages/About9';
import TermsAndConditions9 from './components/Templates/Template9Pages/TermsAndConditions9';
import PrivacyPolicy9 from './components/Templates/Template9Pages/PrivacyPolicy9';
import ShippingAndExchange9 from './components/Templates/Template9Pages/ShippingAndExchange9';
import FAQs9 from './components/Templates/Template9Pages/FAQs9';
import About10 from './components/Templates/Template10Pages/About10';
import TermsAndConditions10 from './components/Templates/Template10Pages/TermsAndConditions10';
import PrivacyPolicy10 from './components/Templates/Template10Pages/PrivacyPolicy10';
import ShippingAndExchange10 from './components/Templates/Template10Pages/ShippingAndExchange10';
import FAQs10 from './components/Templates/Template10Pages/FAQs10';
import About11 from './components/Templates/Template11Pages/About11';
import TermsAndConditions11 from './components/Templates/Template11Pages/TermsAndConditions11';
import PrivacyPolicy11 from './components/Templates/Template11Pages/PrivacyPolicy11';
import ShippingAndExchange11 from './components/Templates/Template11Pages/ShippingAndExchange11';
import FAQs11 from './components/Templates/Template11Pages/FAQs11';
import About12 from './components/Templates/Template12Pages/About12';
import TermsAndConditions12 from './components/Templates/Template12Pages/TermsAndConditions12';
import PrivacyPolicy12 from './components/Templates/Template12Pages/PrivacyPolicy12';
import ShippingAndExchange12 from './components/Templates/Template12Pages/ShippingAndExchange12';
import FAQs12 from './components/Templates/Template12Pages/FAQs12';
import About13 from './components/Templates/Template13Pages/About13';
import TermsAndConditions13 from './components/Templates/Template13Pages/TermsAndConditions13';
import PrivacyPolicy13 from './components/Templates/Template13Pages/PrivacyPolicy13';
import ShippingAndExchange13 from './components/Templates/Template13Pages/ShippingAndExchange13';
import FAQs13 from './components/Templates/Template13Pages/FAQs13';
import About14 from './components/Templates/Template14Pages/About14';
import TermsAndConditions14 from './components/Templates/Template14Pages/TermsAndConditions14';
import PrivacyPolicy14 from './components/Templates/Template14Pages/PrivacyPolicy14';
import ShippingAndExchange14 from './components/Templates/Template14Pages/ShippingAndExchange14';
import FAQs14 from './components/Templates/Template14Pages/FAQs14';
import About15 from './components/Templates/Template15Pages/About15';
import TermsAndConditions15 from './components/Templates/Template15Pages/TermsAndConditions15';
import PrivacyPolicy15 from './components/Templates/Template15Pages/PrivacyPolicy15';
import ShippingAndExchange15 from './components/Templates/Template15Pages/ShippingAndExchange15';
import FAQs15 from './components/Templates/Template15Pages/FAQs15';
import About16 from './components/Templates/Template16Pages/About16';
import TermsAndConditions16 from './components/Templates/Template16Pages/TermsAndConditions16';
import PrivacyPolicy16 from './components/Templates/Template16Pages/PrivacyPolicy16';
import ShippingAndExchange16 from './components/Templates/Template16Pages/ShippingAndExchange16';
import FAQs16 from './components/Templates/Template16Pages/FAQs16';
import About17 from './components/Templates/Template17Pages/About17';
import TermsAndConditions17 from './components/Templates/Template17Pages/TermsAndConditions17';
import PrivacyPolicy17 from './components/Templates/Template17Pages/PrivacyPolicy17';
import ShippingAndExchange17 from './components/Templates/Template17Pages/ShippingAndExchange17';
import FAQs17 from './components/Templates/Template17Pages/FAQs17';
import About18 from './components/Templates/Template18Pages/About18';
import TermsAndConditions18 from './components/Templates/Template18Pages/TermsAndConditions18';
import PrivacyPolicy18 from './components/Templates/Template18Pages/PrivacyPolicy18';
import ShippingAndExchange18 from './components/Templates/Template18Pages/ShippingAndExchange18';
import FAQs18 from './components/Templates/Template18Pages/FAQs18';
import About19 from './components/Templates/Template19Pages/About19';
import TermsAndConditions19 from './components/Templates/Template19Pages/TermsAndConditions19';
import PrivacyPolicy19 from './components/Templates/Template19Pages/PrivacyPolicy19';
import ShippingAndExchange19 from './components/Templates/Template19Pages/ShippingAndExchange19';
import FAQs19 from './components/Templates/Template19Pages/FAQs19';
import About20 from './components/Templates/Template20Pages/About20';
import TermsAndConditions20 from './components/Templates/Template20Pages/TermsAndConditions20';
import PrivacyPolicy20 from './components/Templates/Template20Pages/PrivacyPolicy20';
import ShippingAndExchange20 from './components/Templates/Template20Pages/ShippingAndExchange20';
import FAQs20 from './components/Templates/Template20Pages/FAQs20';
import Template21Shop from './components/Templates/Template21Pages/shop21';
import Template21ProductDetail from './components/Templates/Template21Pages/ProductDetail21';
import Template21Cart from './components/Templates/Template21Pages/Cart21';
import Template21Checkout from './components/Templates/Template21Pages/Checkout21';
import Template21Login from './components/Templates/Template21Pages/Login21';
import Template21Signup from './components/Templates/Template21Pages/Signup21';
import Template21Orders from './components/Templates/Template21Pages/Orders21';
import Template21Contact from './components/Templates/Template21Pages/Contact21';
import Template21Profile from './components/Templates/Template21Pages/Profile21';
import About21 from './components/Templates/Template21Pages/About21';
import TermsAndConditions21 from './components/Templates/Template21Pages/TermsAndConditions21';
import PrivacyPolicy21 from './components/Templates/Template21Pages/PrivacyPolicy21';
import ShippingAndExchange21 from './components/Templates/Template21Pages/ShippingAndExchange21';
import FAQs21 from './components/Templates/Template21Pages/FAQs21';
import Template22Shop from './components/Templates/Template22Pages/shop22';
import Template22ProductDetail from './components/Templates/Template22Pages/ProductDetail22';
import Template22Cart from './components/Templates/Template22Pages/Cart22';
import Template22Checkout from './components/Templates/Template22Pages/Checkout22';
import Template22Login from './components/Templates/Template22Pages/Login22';
import Template22Signup from './components/Templates/Template22Pages/Signup22';
import Template22Orders from './components/Templates/Template22Pages/Orders22';
import Template22Contact from './components/Templates/Template22Pages/Contact22';
import Template22Profile from './components/Templates/Template22Pages/Profile22';
import About22 from './components/Templates/Template22Pages/About22';
import TermsAndConditions22 from './components/Templates/Template22Pages/TermsAndConditions22';
import PrivacyPolicy22 from './components/Templates/Template22Pages/PrivacyPolicy22';
import ShippingAndExchange22 from './components/Templates/Template22Pages/ShippingAndExchange22';
import FAQs22 from './components/Templates/Template22Pages/FAQs22';
import Template23Shop from './components/Templates/Template23Pages/shop23';
import Template23ProductDetail from './components/Templates/Template23Pages/ProductDetail23';
import Template23Cart from './components/Templates/Template23Pages/Cart23';
import Template23Checkout from './components/Templates/Template23Pages/Checkout23';
import Template23Login from './components/Templates/Template23Pages/Login23';
import Template23Signup from './components/Templates/Template23Pages/Signup23';
import Template23Orders from './components/Templates/Template23Pages/Orders23';
import Template23Contact from './components/Templates/Template23Pages/Contact23';
import Template23Profile from './components/Templates/Template23Pages/Profile23';
import About23 from './components/Templates/Template23Pages/About23';
import TermsAndConditions23 from './components/Templates/Template23Pages/TermsAndConditions23';
import PrivacyPolicy23 from './components/Templates/Template23Pages/PrivacyPolicy23';
import ShippingAndExchange23 from './components/Templates/Template23Pages/ShippingAndExchange23';
import FAQs23 from './components/Templates/Template23Pages/FAQs23';
import Template24Shop from './components/Templates/Template24Pages/shop24';
import Template24ProductDetail from './components/Templates/Template24Pages/ProductDetail24';
import Template24Cart from './components/Templates/Template24Pages/Cart24';
import Template24Checkout from './components/Templates/Template24Pages/Checkout24';
import Template24Login from './components/Templates/Template24Pages/Login24';
import Template24Signup from './components/Templates/Template24Pages/Signup24';
import Template24Orders from './components/Templates/Template24Pages/Orders24';
import Template24Contact from './components/Templates/Template24Pages/Contact24';
import Template24Profile from './components/Templates/Template24Pages/Profile24';
import About24 from './components/Templates/Template24Pages/About24';
import TermsAndConditions24 from './components/Templates/Template24Pages/TermsAndConditions24';
import PrivacyPolicy24 from './components/Templates/Template24Pages/PrivacyPolicy24';
import ShippingAndExchange24 from './components/Templates/Template24Pages/ShippingAndExchange24';
import FAQs24 from './components/Templates/Template24Pages/FAQs24';
import Template25Shop from './components/Templates/Template25Pages/shop25';
import Template25ProductDetail from './components/Templates/Template25Pages/ProductDetail25';
import Template25Cart from './components/Templates/Template25Pages/Cart25';
import Template25Checkout from './components/Templates/Template25Pages/Checkout25';
import Template25Login from './components/Templates/Template25Pages/Login25';
import Template25Signup from './components/Templates/Template25Pages/Signup25';
import Template25Orders from './components/Templates/Template25Pages/Orders25';
import Template25Contact from './components/Templates/Template25Pages/Contact25';
import Template25Profile from './components/Templates/Template25Pages/Profile25';
import About25 from './components/Templates/Template25Pages/About25';
import TermsAndConditions25 from './components/Templates/Template25Pages/TermsAndConditions25';
import PrivacyPolicy25 from './components/Templates/Template25Pages/PrivacyPolicy25';
import ShippingAndExchange25 from './components/Templates/Template25Pages/ShippingAndExchange25';
import FAQs25 from './components/Templates/Template25Pages/FAQs25';


function App() {
  return (
    <ErrorBoundary>
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/old-landing" element={<LandingPage />} />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/login" element={<Login />} />
          <Route path="/termsNconditions" element={<TermsAndServices/>} />
          <Route path="/payShip" element={<PaymentShipping/>} />
          <Route path="/rtnPolicy" element={<ReturnPolicy/>} />
          <Route path="/privacyPolicy" element={<PrivacyPolicy/>} />
          <Route path="/Faqs" element={<Faqs/>} />
          <Route path="/forgot-password" element={<ForgotPassword/>} />
          <Route
            path="/homepage"
            element={
              <PrivateRoute>
                <HomePage />
              </PrivateRoute>
            }
          />
          <Route
            path="/UploadProduct"
            element={
              <PrivateRoute>
                <Uploadproduct/>
              </PrivateRoute>
            }
          />
          <Route
            path="/EditProduct/:productId"
            element={
              <PrivateRoute>
                <EditProduct/>
              </PrivateRoute>
            }
          />
          <Route
            path="/Base"
            element={
              <PrivateRoute>
                <Base/>
              </PrivateRoute>
            }
          />
          <Route
            path="/Profile"
            element={
              <PrivateRoute>
                <Profile/>
              </PrivateRoute>
            }
          />
          <Route
            path="/my-coupons"
            element={
              <PrivateRoute>
                <MyCoupons/>
              </PrivateRoute>
            }
          />
          <Route
            path="/collections-manager"
            element={
              <PrivateRoute>
                <CollectionsManager/>
              </PrivateRoute>
            }
          />
          <Route
            path="/TemplateThemes"
            element={
              <PrivateRoute>
                <TemplateThemes/>
              </PrivateRoute>
            }
          />
          <Route
            path="/visual-editor"
            element={
              <PrivateRoute>
                <VisualTemplateEditor/>
              </PrivateRoute>
            }
          />
          <Route
            path="/template-builder/:templateId"
            element={
              <PrivateRoute>
                <PageDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/Contact"
            element={
              <PrivateRoute>
                <Contact/>
              </PrivateRoute>
            }
          />
          <Route
            path="/AboutMe"
            element={
              <PrivateRoute>
                <AboutMe/>
              </PrivateRoute>
            }
          />
          <Route
            path="/Orders"
            element={
              <PrivateRoute>
                <Orders/>
              </PrivateRoute>
            }
          />
          <Route
            path="/orderbook"
            element={
              <PrivateRoute>
                <OrderBook/>
              </PrivateRoute>
            }
          />
          <Route
            path="/analytics"
            element={
              <PrivateRoute>
                <Analytics/>
              </PrivateRoute>
            }
          />
          <Route
            path="/seo-settings"
            element={
              <PrivateRoute>
                <SEOSettings/>
              </PrivateRoute>
            }
          />
          <Route
            path="/Proposals"
            element={
              <PrivateRoute>
                <Proposals/>
              </PrivateRoute>
            }
          />
          <Route
            path="/subscription"
            element={
              <PrivateRoute>
                <TemplateSelector />
              </PrivateRoute>
            }
          />
          <Route
            path="/vasstr-admin"
            element={
              <AdminRoute>
                <AdminDashboard/>
              </AdminRoute>
            }
          />
          <Route
            path="/designer-onboarding"
            element={
              <PrivateRoute>
                <DesignerOnboarding/>
              </PrivateRoute>
            }
          />
          <Route
            path="/admin-designers"
            element={
              <AdminRoute>
                <AdminDesignerDashboard/>
              </AdminRoute>
            }
          />
          <Route
            path="/designer-profile"
            element={
              <PrivateRoute>
                <DesignerProfile/>
              </PrivateRoute>
            }
          />
          <Route path="/Register" element={<Register/>}/>

          <Route path="/template1" element={<Template1 />} />
          <Route path="/template2" element={<Template2 />} />
          <Route path="/template3" element={<Template3 />} />
          <Route path="/template4" element={<Template4 />} />
          <Route path="/template5" element={<Template5 />} />
          <Route path="/template6" element={<Template6 />} />
          <Route path="/template7" element={<Template7 />} />
          <Route path="/template8" element={<Template8 />} />
          <Route path="/template9" element={<Template9 />} />
          <Route path="/template10" element={<Template10 />} />
          <Route path="/template11" element={<Template11 />} />
          <Route path="/template12" element={<Template12 />} />
          <Route path="/template13" element={<Template13 />} />
          <Route path="/template14" element={<Template14 />} />
          <Route path="/template15" element={<Template15 />} />
          <Route path="/template16" element={<Template16 />} />
          <Route path="/template17" element={<Template17 />} />
          <Route path="/template18" element={<Template18 />} />
          <Route path="/template19" element={<Template19 />} />
          <Route path="/template20" element={<Template20 />} />
          <Route path="/template21" element={<Template21 />} />
          <Route path="/template22" element={<Template22 />} />
          <Route path="/template23" element={<Template23 />} />
          <Route path="/template24" element={<Template24 />} />
          <Route path="/template25" element={<Template25 />} />

          {/* Template1 Multi-Page Routes */}
          <Route path="/template1/shop" element={<Template1Shop />} />
          <Route path="/template1/product/:id" element={<Template1ProductDetail />} />
          <Route path="/template1/cart" element={<Template1Cart />} />
          <Route path="/template1/checkout" element={<Template1Checkout />} />
          <Route path="/template1/login" element={<Template1Login />} />
          <Route path="/template1/signup" element={<Template1Signup />} />
          <Route path="/template1/orders" element={<Template1Orders />} />
          <Route path="/template1/contact" element={<Template1Contact />} />
          <Route path="/template1/profile" element={<Template1Profile />} />
          <Route path="/template1/about" element={<Template1About />} />
          <Route path="/template1/terms-conditions" element={<Template1TermsAndConditions />} />
          <Route path="/template1/privacy-policy" element={<Template1PrivacyPolicy />} />
          <Route path="/template1/shipping-exchange" element={<Template1ShippingAndExchange />} />
          <Route path="/template1/faqs" element={<Template1FAQs />} />

                    {/* Template2 Multi-Page Routes */}
          <Route path="/template2/shop" element={<Template2Shop />} />
          <Route path="/template2/product/:id" element={<Template2ProductDetail />} />
          <Route path="/template2/cart" element={<Template2Cart />} />
          <Route path="/template2/checkout" element={<Template2Checkout />} />
          <Route path="/template2/login" element={<Template2Login />} />
          <Route path="/template2/signup" element={<Template2Signup />} />
          <Route path="/template2/orders" element={<Template2Orders />} />
          <Route path="/template2/contact" element={<Template2Contact />} />
          <Route path="/template2/profile" element={<Template2Profile />} />
          <Route path="/template2/about" element={<About2 />} />
          <Route path="/template2/terms-conditions" element={<TermsAndConditions2 />} />
          <Route path="/template2/privacy-policy" element={<PrivacyPolicy2 />} />
          <Route path="/template2/shipping-exchange" element={<ShippingAndExchange2 />} />
          <Route path="/template2/faqs" element={<FAQs2 />} />

          {/* Template3 Multi-Page Routes */}
          <Route path="/template3/shop" element={<Template3Shop />} />
          <Route path="/template3/product/:id" element={<Template3ProductDetail />} />
          <Route path="/template3/cart" element={<Template3Cart />} />
          <Route path="/template3/checkout" element={<Template3Checkout />} />
          <Route path="/template3/login" element={<Template3Login />} />
          <Route path="/template3/signup" element={<Template3Signup />} />
          <Route path="/template3/orders" element={<Template3Orders />} />
          <Route path="/template3/contact" element={<Template3Contact />} />
          <Route path="/template3/profile" element={<Template3Profile />} />
          <Route path="/template3/about" element={<About3 />} />
          <Route path="/template3/terms-conditions" element={<TermsAndConditions3 />} />
          <Route path="/template3/privacy-policy" element={<PrivacyPolicy3 />} />
          <Route path="/template3/shipping-exchange" element={<ShippingAndExchange3 />} />
          <Route path="/template3/faqs" element={<FAQs3 />} />

          {/* Template4 Multi-Page Routes */}
          <Route path="/template4/shop" element={<Template4Shop />} />
          <Route path="/template4/product/:id" element={<Template4ProductDetail />} />
          <Route path="/template4/cart" element={<Template4Cart />} />
          <Route path="/template4/checkout" element={<Template4Checkout />} />
          <Route path="/template4/login" element={<Template4Login />} />
          <Route path="/template4/signup" element={<Template4Signup />} />
          <Route path="/template4/orders" element={<Template4Orders />} />
          <Route path="/template4/contact" element={<Template4Contact />} />
          <Route path="/template4/profile" element={<Template4Profile />} />
          <Route path="/template4/about" element={<About4 />} />
          <Route path="/template4/terms-conditions" element={<TermsAndConditions4 />} />
          <Route path="/template4/privacy-policy" element={<PrivacyPolicy4 />} />
          <Route path="/template4/shipping-exchange" element={<ShippingAndExchange4 />} />
          <Route path="/template4/faqs" element={<FAQs4 />} />

          {/* Template5 Multi-Page Routes */}
          <Route path="/template5/shop" element={<Template5Shop />} />
          <Route path="/template5/product/:id" element={<Template5ProductDetail />} />
          <Route path="/template5/cart" element={<Template5Cart />} />
          <Route path="/template5/checkout" element={<Template5Checkout />} />
          <Route path="/template5/login" element={<Template5Login />} />
          <Route path="/template5/signup" element={<Template5Signup />} />
          <Route path="/template5/orders" element={<Template5Orders />} />
          <Route path="/template5/contact" element={<Template5Contact />} />
          <Route path="/template5/profile" element={<Template5Profile />} />
          <Route path="/template5/about" element={<About5 />} />
          <Route path="/template5/terms-conditions" element={<TermsAndConditions5 />} />
          <Route path="/template5/privacy-policy" element={<PrivacyPolicy5 />} />
          <Route path="/template5/shipping-exchange" element={<ShippingAndExchange5 />} />
          <Route path="/template5/faqs" element={<FAQs5 />} />

          {/* Template6 Multi-Page Routes */}
          <Route path="/template6/shop" element={<Template6Shop />} />
          <Route path="/template6/product/:id" element={<Template6ProductDetail />} />
          <Route path="/template6/cart" element={<Template6Cart />} />
          <Route path="/template6/checkout" element={<Template6Checkout />} />
          <Route path="/template6/login" element={<Template6Login />} />
          <Route path="/template6/signup" element={<Template6Signup />} />
          <Route path="/template6/orders" element={<Template6Orders />} />
          <Route path="/template6/contact" element={<Template6Contact />} />
          <Route path="/template6/profile" element={<Template6Profile />} />
          <Route path="/template6/about" element={<About6 />} />
          <Route path="/template6/terms-conditions" element={<TermsAndConditions6 />} />
          <Route path="/template6/privacy-policy" element={<PrivacyPolicy6 />} />
          <Route path="/template6/shipping-exchange" element={<ShippingAndExchange6 />} />
          <Route path="/template6/faqs" element={<FAQs6 />} />

          {/* Template7 Multi-Page Routes */}
          <Route path="/template7/shop" element={<Template7Shop />} />
          <Route path="/template7/product/:id" element={<Template7ProductDetail />} />
          <Route path="/template7/cart" element={<Template7Cart />} />
          <Route path="/template7/checkout" element={<Template7Checkout />} />
          <Route path="/template7/login" element={<Template7Login />} />
          <Route path="/template7/signup" element={<Template7Signup />} />
          <Route path="/template7/orders" element={<Template7Orders />} />
          <Route path="/template7/contact" element={<Template7Contact />} />
          <Route path="/template7/profile" element={<Template7Profile />} />
          <Route path="/template7/about" element={<About7 />} />
          <Route path="/template7/terms-conditions" element={<TermsAndConditions7 />} />
          <Route path="/template7/privacy-policy" element={<PrivacyPolicy7 />} />
          <Route path="/template7/shipping-exchange" element={<ShippingAndExchange7 />} />
          <Route path="/template7/faqs" element={<FAQs7 />} />

          {/* Template8 Multi-Page Routes */}
          <Route path="/template8/shop" element={<Template8Shop />} />
          <Route path="/template8/product/:id" element={<Template8ProductDetail />} />
          <Route path="/template8/cart" element={<Template8Cart />} />
          <Route path="/template8/checkout" element={<Template8Checkout />} />
          <Route path="/template8/login" element={<Template8Login />} />
          <Route path="/template8/signup" element={<Template8Signup />} />
          <Route path="/template8/orders" element={<Template8Orders />} />
          <Route path="/template8/contact" element={<Template8Contact />} />
          <Route path="/template8/profile" element={<Template8Profile />} />
          <Route path="/template8/about" element={<About8 />} />
          <Route path="/template8/terms-conditions" element={<TermsAndConditions8 />} />
          <Route path="/template8/privacy-policy" element={<PrivacyPolicy8 />} />
          <Route path="/template8/shipping-exchange" element={<ShippingAndExchange8 />} />
          <Route path="/template8/faqs" element={<FAQs8 />} />

          {/* Template9 Multi-Page Routes */}
          <Route path="/template9/shop" element={<Template9Shop />} />
          <Route path="/template9/product/:id" element={<Template9ProductDetail />} />
          <Route path="/template9/cart" element={<Template9Cart />} />
          <Route path="/template9/checkout" element={<Template9Checkout />} />
          <Route path="/template9/login" element={<Template9Login />} />
          <Route path="/template9/signup" element={<Template9Signup />} />
          <Route path="/template9/orders" element={<Template9Orders />} />
          <Route path="/template9/contact" element={<Template9Contact />} />
          <Route path="/template9/profile" element={<Template9Profile />} />
          <Route path="/template9/about" element={<About9 />} />
          <Route path="/template9/terms-conditions" element={<TermsAndConditions9 />} />
          <Route path="/template9/privacy-policy" element={<PrivacyPolicy9 />} />
          <Route path="/template9/shipping-exchange" element={<ShippingAndExchange9 />} />
          <Route path="/template9/faqs" element={<FAQs9 />} />

          {/* Template10 Multi-Page Routes */}
          <Route path="/template10/shop" element={<Template10Shop />} />
          <Route path="/template10/product/:id" element={<Template10ProductDetail />} />
          <Route path="/template10/cart" element={<Template10Cart />} />
          <Route path="/template10/checkout" element={<Template10Checkout />} />
          <Route path="/template10/login" element={<Template10Login />} />
          <Route path="/template10/signup" element={<Template10Signup />} />
          <Route path="/template10/orders" element={<Template10Orders />} />
          <Route path="/template10/contact" element={<Template10Contact />} />
          <Route path="/template10/profile" element={<Template10Profile />} />
          <Route path="/template10/about" element={<About10 />} />
          <Route path="/template10/terms-conditions" element={<TermsAndConditions10 />} />
          <Route path="/template10/privacy-policy" element={<PrivacyPolicy10 />} />
          <Route path="/template10/shipping-exchange" element={<ShippingAndExchange10 />} />
          <Route path="/template10/faqs" element={<FAQs10 />} />

          {/* Template11 Multi-Page Routes */}
          <Route path="/template11/shop" element={<Template11Shop />} />
          <Route path="/template11/product/:id" element={<Template11ProductDetail />} />
          <Route path="/template11/cart" element={<Template11Cart />} />
          <Route path="/template11/checkout" element={<Template11Checkout />} />
          <Route path="/template11/login" element={<Template11Login />} />
          <Route path="/template11/signup" element={<Template11Signup />} />
          <Route path="/template11/orders" element={<Template11Orders />} />
          <Route path="/template11/contact" element={<Template11Contact />} />
          <Route path="/template11/profile" element={<Template11Profile />} />
          <Route path="/template11/about" element={<About11 />} />
          <Route path="/template11/terms-conditions" element={<TermsAndConditions11 />} />
          <Route path="/template11/privacy-policy" element={<PrivacyPolicy11 />} />
          <Route path="/template11/shipping-exchange" element={<ShippingAndExchange11 />} />
          <Route path="/template11/faqs" element={<FAQs11 />} />

          {/* Template12 Multi-Page Routes */}
          <Route path="/template12/shop" element={<Template12Shop />} />
          <Route path="/template12/product/:id" element={<Template12ProductDetail />} />
          <Route path="/template12/cart" element={<Template12Cart />} />
          <Route path="/template12/checkout" element={<Template12Checkout />} />
          <Route path="/template12/login" element={<Template12Login />} />
          <Route path="/template12/signup" element={<Template12Signup />} />
          <Route path="/template12/orders" element={<Template12Orders />} />
          <Route path="/template12/contact" element={<Template12Contact />} />
          <Route path="/template12/profile" element={<Template12Profile />} />
          <Route path="/template12/about" element={<About12 />} />
          <Route path="/template12/terms-conditions" element={<TermsAndConditions12 />} />
          <Route path="/template12/privacy-policy" element={<PrivacyPolicy12 />} />
          <Route path="/template12/shipping-exchange" element={<ShippingAndExchange12 />} />
          <Route path="/template12/faqs" element={<FAQs12 />} />

          {/* Template13 Multi-Page Routes */}
          <Route path="/template13/shop" element={<Template13Shop />} />
          <Route path="/template13/product/:id" element={<Template13ProductDetail />} />
          <Route path="/template13/cart" element={<Template13Cart />} />
          <Route path="/template13/checkout" element={<Template13Checkout />} />
          <Route path="/template13/login" element={<Template13Login />} />
          <Route path="/template13/signup" element={<Template13Signup />} />
          <Route path="/template13/orders" element={<Template13Orders />} />
          <Route path="/template13/contact" element={<Template13Contact />} />
          <Route path="/template13/profile" element={<Template13Profile />} />
          <Route path="/template13/about" element={<About13 />} />
          <Route path="/template13/terms-conditions" element={<TermsAndConditions13 />} />
          <Route path="/template13/privacy-policy" element={<PrivacyPolicy13 />} />
          <Route path="/template13/shipping-exchange" element={<ShippingAndExchange13 />} />
          <Route path="/template13/faqs" element={<FAQs13 />} />

          {/* Template14 Multi-Page Routes */}
          <Route path="/template14/shop" element={<Template14Shop />} />
          <Route path="/template14/product/:id" element={<Template14ProductDetail />} />
          <Route path="/template14/cart" element={<Template14Cart />} />
          <Route path="/template14/checkout" element={<Template14Checkout />} />
          <Route path="/template14/login" element={<Template14Login />} />
          <Route path="/template14/signup" element={<Template14Signup />} />
          <Route path="/template14/orders" element={<Template14Orders />} />
          <Route path="/template14/contact" element={<Template14Contact />} />
          <Route path="/template14/profile" element={<Template14Profile />} />
          <Route path="/template14/about" element={<About14 />} />
          <Route path="/template14/terms-conditions" element={<TermsAndConditions14 />} />
          <Route path="/template14/privacy-policy" element={<PrivacyPolicy14 />} />
          <Route path="/template14/shipping-exchange" element={<ShippingAndExchange14 />} />
          <Route path="/template14/faqs" element={<FAQs14 />} />

          {/* Template15 Multi-Page Routes */}
          <Route path="/template15/shop" element={<Template15Shop />} />
          <Route path="/template15/product/:id" element={<Template15ProductDetail />} />
          <Route path="/template15/cart" element={<Template15Cart />} />
          <Route path="/template15/checkout" element={<Template15Checkout />} />
          <Route path="/template15/login" element={<Template15Login />} />
          <Route path="/template15/signup" element={<Template15Signup />} />
          <Route path="/template15/orders" element={<Template15Orders />} />
          <Route path="/template15/contact" element={<Template15Contact />} />
          <Route path="/template15/profile" element={<Template15Profile />} />
          <Route path="/template15/about" element={<About15 />} />
          <Route path="/template15/terms-conditions" element={<TermsAndConditions15 />} />
          <Route path="/template15/privacy-policy" element={<PrivacyPolicy15 />} />
          <Route path="/template15/shipping-exchange" element={<ShippingAndExchange15 />} />
          <Route path="/template15/faqs" element={<FAQs15 />} />

          {/* Template16 Multi-Page Routes */}
          <Route path="/template16/shop" element={<Template16Shop />} />
          <Route path="/template16/product/:id" element={<Template16ProductDetail />} />
          <Route path="/template16/cart" element={<Template16Cart />} />
          <Route path="/template16/checkout" element={<Template16Checkout />} />
          <Route path="/template16/login" element={<Template16Login />} />
          <Route path="/template16/signup" element={<Template16Signup />} />
          <Route path="/template16/orders" element={<Template16Orders />} />
          <Route path="/template16/contact" element={<Template16Contact />} />
          <Route path="/template16/profile" element={<Template16Profile />} />
          <Route path="/template16/about" element={<About16 />} />
          <Route path="/template16/terms-conditions" element={<TermsAndConditions16 />} />
          <Route path="/template16/privacy-policy" element={<PrivacyPolicy16 />} />
          <Route path="/template16/shipping-exchange" element={<ShippingAndExchange16 />} />
          <Route path="/template16/faqs" element={<FAQs16 />} />

          {/* Template17 Multi-Page Routes */}
          <Route path="/template17/shop" element={<Template17Shop />} />
          <Route path="/template17/product/:id" element={<Template17ProductDetail />} />
          <Route path="/template17/cart" element={<Template17Cart />} />
          <Route path="/template17/checkout" element={<Template17Checkout />} />
          <Route path="/template17/login" element={<Template17Login />} />
          <Route path="/template17/signup" element={<Template17Signup />} />
          <Route path="/template17/orders" element={<Template17Orders />} />
          <Route path="/template17/contact" element={<Template17Contact />} />
          <Route path="/template17/profile" element={<Template17Profile />} />
          <Route path="/template17/about" element={<About17 />} />
          <Route path="/template17/terms-conditions" element={<TermsAndConditions17 />} />
          <Route path="/template17/privacy-policy" element={<PrivacyPolicy17 />} />
          <Route path="/template17/shipping-exchange" element={<ShippingAndExchange17 />} />
          <Route path="/template17/faqs" element={<FAQs17 />} />

          {/* Template18 Multi-Page Routes */}
          <Route path="/template18/shop" element={<Template18Shop />} />
          <Route path="/template18/product/:id" element={<Template18ProductDetail />} />
          <Route path="/template18/cart" element={<Template18Cart />} />
          <Route path="/template18/checkout" element={<Template18Checkout />} />
          <Route path="/template18/login" element={<Template18Login />} />
          <Route path="/template18/signup" element={<Template18Signup />} />
          <Route path="/template18/orders" element={<Template18Orders />} />
          <Route path="/template18/contact" element={<Template18Contact />} />
          <Route path="/template18/profile" element={<Template18Profile />} />
          <Route path="/template18/about" element={<About18 />} />
          <Route path="/template18/terms-conditions" element={<TermsAndConditions18 />} />
          <Route path="/template18/privacy-policy" element={<PrivacyPolicy18 />} />
          <Route path="/template18/shipping-exchange" element={<ShippingAndExchange18 />} />
          <Route path="/template18/faqs" element={<FAQs18 />} />

          {/* Template19 Multi-Page Routes */}
          <Route path="/template19/shop" element={<Template19Shop />} />
          <Route path="/template19/product/:id" element={<Template19ProductDetail />} />
          <Route path="/template19/cart" element={<Template19Cart />} />
          <Route path="/template19/checkout" element={<Template19Checkout />} />
          <Route path="/template19/login" element={<Template19Login />} />
          <Route path="/template19/signup" element={<Template19Signup />} />
          <Route path="/template19/orders" element={<Template19Orders />} />
          <Route path="/template19/contact" element={<Template19Contact />} />
          <Route path="/template19/profile" element={<Template19Profile />} />
          <Route path="/template19/about" element={<About19 />} />
          <Route path="/template19/terms-conditions" element={<TermsAndConditions19 />} />
          <Route path="/template19/privacy-policy" element={<PrivacyPolicy19 />} />
          <Route path="/template19/shipping-exchange" element={<ShippingAndExchange19 />} />
          <Route path="/template19/faqs" element={<FAQs19 />} />

{/* Template20 Multi-Page Routes */}
          <Route path="/template20/shop" element={<Template20Shop />} />
          <Route path="/template20/product/:id" element={<Template20ProductDetail />} />
          <Route path="/template20/cart" element={<Template20Cart />} />
          <Route path="/template20/checkout" element={<Template20Checkout />} />
          <Route path="/template20/login" element={<Template20Login />} />
          <Route path="/template20/signup" element={<Template20Signup />} />
          <Route path="/template20/orders" element={<Template20Orders />} />
          <Route path="/template20/contact" element={<Template20Contact />} />
          <Route path="/template20/profile" element={<Template20Profile />} />
          <Route path="/template20/about" element={<About20 />} />
          <Route path="/template20/terms-conditions" element={<TermsAndConditions20 />} />
          <Route path="/template20/privacy-policy" element={<PrivacyPolicy20 />} />
          <Route path="/template20/shipping-exchange" element={<ShippingAndExchange20 />} />
          <Route path="/template20/faqs" element={<FAQs20 />} />

          {/* Template21 Multi-Page Routes */}
          <Route path="/template21/shop" element={<Template21Shop />} />
          <Route path="/template21/product/:id" element={<Template21ProductDetail />} />
          <Route path="/template21/cart" element={<Template21Cart />} />
          <Route path="/template21/checkout" element={<Template21Checkout />} />
          <Route path="/template21/login" element={<Template21Login />} />
          <Route path="/template21/signup" element={<Template21Signup />} />
          <Route path="/template21/orders" element={<Template21Orders />} />
          <Route path="/template21/contact" element={<Template21Contact />} />
          <Route path="/template21/profile" element={<Template21Profile />} />
          <Route path="/template21/about" element={<About21 />} />
          <Route path="/template21/terms-conditions" element={<TermsAndConditions21 />} />
          <Route path="/template21/privacy-policy" element={<PrivacyPolicy21 />} />
          <Route path="/template21/shipping-exchange" element={<ShippingAndExchange21 />} />
          <Route path="/template21/faqs" element={<FAQs21 />} />
          {/* Template22 Multi-Page Routes */}
          <Route path="/template22/shop" element={<Template22Shop />} />
          <Route path="/template22/product/:id" element={<Template22ProductDetail />} />
          <Route path="/template22/cart" element={<Template22Cart />} />
          <Route path="/template22/checkout" element={<Template22Checkout />} />
          <Route path="/template22/login" element={<Template22Login />} />
          <Route path="/template22/signup" element={<Template22Signup />} />
          <Route path="/template22/orders" element={<Template22Orders />} />
          <Route path="/template22/contact" element={<Template22Contact />} />
          <Route path="/template22/profile" element={<Template22Profile />} />
          <Route path="/template22/about" element={<About22 />} />
          <Route path="/template22/terms-conditions" element={<TermsAndConditions22 />} />
          <Route path="/template22/privacy-policy" element={<PrivacyPolicy22 />} />
          <Route path="/template22/shipping-exchange" element={<ShippingAndExchange22 />} />
          <Route path="/template22/faqs" element={<FAQs22 />} />
          {/* Template23 Multi-Page Routes */}
          <Route path="/template23/shop" element={<Template23Shop />} />
          <Route path="/template23/product/:id" element={<Template23ProductDetail />} />
          <Route path="/template23/cart" element={<Template23Cart />} />
          <Route path="/template23/checkout" element={<Template23Checkout />} />
          <Route path="/template23/login" element={<Template23Login />} />
          <Route path="/template23/signup" element={<Template23Signup />} />
          <Route path="/template23/orders" element={<Template23Orders />} />
          <Route path="/template23/contact" element={<Template23Contact />} />
          <Route path="/template23/profile" element={<Template23Profile />} />
          <Route path="/template23/about" element={<About23 />} />
          <Route path="/template23/terms-conditions" element={<TermsAndConditions23 />} />
          <Route path="/template23/privacy-policy" element={<PrivacyPolicy23 />} />
          <Route path="/template23/shipping-exchange" element={<ShippingAndExchange23 />} />
          <Route path="/template23/faqs" element={<FAQs23 />} />
          {/* Template24 Multi-Page Routes */}
          <Route path="/template24/shop" element={<Template24Shop />} />
          <Route path="/template24/product/:id" element={<Template24ProductDetail />} />
          <Route path="/template24/cart" element={<Template24Cart />} />
          <Route path="/template24/checkout" element={<Template24Checkout />} />
          <Route path="/template24/login" element={<Template24Login />} />
          <Route path="/template24/signup" element={<Template24Signup />} />
          <Route path="/template24/orders" element={<Template24Orders />} />
          <Route path="/template24/contact" element={<Template24Contact />} />
          <Route path="/template24/profile" element={<Template24Profile />} />
          <Route path="/template24/about" element={<About24 />} />
          <Route path="/template24/terms-conditions" element={<TermsAndConditions24 />} />
          <Route path="/template24/privacy-policy" element={<PrivacyPolicy24 />} />
          <Route path="/template24/shipping-exchange" element={<ShippingAndExchange24 />} />
          <Route path="/template24/faqs" element={<FAQs24 />} />
          {/* Template25 Multi-Page Routes */}
          <Route path="/template25/shop" element={<Template25Shop />} />
          <Route path="/template25/product/:id" element={<Template25ProductDetail />} />
          <Route path="/template25/cart" element={<Template25Cart />} />
          <Route path="/template25/checkout" element={<Template25Checkout />} />
          <Route path="/template25/login" element={<Template25Login />} />
          <Route path="/template25/signup" element={<Template25Signup />} />
          <Route path="/template25/orders" element={<Template25Orders />} />
          <Route path="/template25/contact" element={<Template25Contact />} />
          <Route path="/template25/profile" element={<Template25Profile />} />
          <Route path="/template25/about" element={<About25 />} />
          <Route path="/template25/terms-conditions" element={<TermsAndConditions25 />} />
          <Route path="/template25/privacy-policy" element={<PrivacyPolicy25 />} />
          <Route path="/template25/shipping-exchange" element={<ShippingAndExchange25 />} />
          <Route path="/template25/faqs" element={<FAQs25 />} />
          <Route path="*" element={<Navigate to="/homepage" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
    </ErrorBoundary>
  );
}

export default App;